import "ngstorage";
import async from "async";

import {
  WALKTHROUGH_STATES,
  TRIGGER_NEXT_EVENT_NAME,
  UPDATE_WORKFLOW_EVENT_NAME,
  DRESS_CODE_DEFAULT,
  SCHEDULING_INTERVALS
} from "../../variables";

let DAYS_OF_WEEK = {
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
  SUNDAY: 0,
};

const GRACE_PERIOD = 1000 * 60 * 60 * 24 * 3;

let DAYS_OF_WEEK_OBJECTS = [
  {
    value: DAYS_OF_WEEK.SUNDAY,
    label: "Sun",
  },
  {
    value: DAYS_OF_WEEK.MONDAY,
    label: "Mon",
  },
  {
    value: DAYS_OF_WEEK.TUESDAY,
    label: "Tue",
  },
  {
    value: DAYS_OF_WEEK.WEDNESDAY,
    label: "Wed",
  },
  {
    value: DAYS_OF_WEEK.THURSDAY,
    label: "Thu",
  },
  {
    value: DAYS_OF_WEEK.FRIDAY,
    label: "Fri",
  },
  {
    value: DAYS_OF_WEEK.SATURDAY,
    label: "Sat",
  },
];

let HOURS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
let MINUTES = ["00", "15", "30", "45"];

class DateandtimeController {
  constructor(
    $localStorage,
    $rootScope,
    $state,
    $stateParams,
    AuthService,
    EnvService,
    SecurityService,
    ngProgressFactory,
    $timeout,
    TrackingService,
    events,
    $location,
    $scope
  ) {
    this.name = "dateandtime";
    this.walkthroughState = WALKTHROUGH_STATES.DATEANDTIME;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$progress = ngProgressFactory.createInstance();
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;
    this.$location = $location;
    this.$scope = $scope;
    this.hide_remote_job = false;

    this.$timeout(() => this.activateDatePickers(), 500);

    this.API_FIELDS =
      "isLongTerm,weeks,subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.jobbleType.name, subEvents.deduppedJobbles.jobbleType.id,subEvents.deduppedJobbles.shifts.id,subEvents.deduppedJobbles.shifts.timeInterval.startTime,subEvents.deduppedJobbles.shifts.timeInterval.endTime,subEvents.deduppedJobbles.shifts.unpaidBreak,subEvents.deduppedJobbles.shifts.overnight,subEvents.deduppedJobbles.shifts.contactInfo.id,subEvents.deduppedJobbles.shifts.contactInfo.streetLine1,subEvents.deduppedJobbles.shifts.contactInfo.place.timeZoneId,subEvents.deduppedJobbles.shifts.contactInfo.city,subEvents.deduppedJobbles.shifts.contactInfo.lat,subEvents.deduppedJobbles.shifts.contactInfo.lng,subEvents.deduppedJobbles.shifts.contactInfo.state,subEvents.deduppedJobbles.shifts.contactInfo.zipCode";

    this.times = this.generateTimes(0);
    this.timeIntervals = SCHEDULING_INTERVALS;

    let timeMap = {};
    this.times.map((time) => {
      timeMap[time.formatted] = time.raw;
    });

    this.timeMap = timeMap;
    this.numberOfWeeksToScheduleJob = "1 Week";
    if (!this.$auth.isAdmin()) this.hide_remote_job = true;

    this.$timeout(() => {
      this.shiftGenerator = this.getNewShiftObject();
      this.shiftLongTermGenerator = this.getNewLongTermShiftObject();
      this.validateShiftGenerator();
    });

    this.DAYS_OF_WEEK = DAYS_OF_WEEK;
    this.DAYS_OF_WEEK_OBJECTS = DAYS_OF_WEEK_OBJECTS;
    this.HOURS = HOURS;
    this.MINUTES = MINUTES;
    this.WEEKS_AVAILABLE = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
    ];

    this.development_env = this.$env.getEnv();

    this.PostAJobGlobalApiSyncLongTermListener = this.$rootScope.$on("PostAJobGlobalApiSyncLongTerm", ($event, params) => {
      let event = params.event;

      if (event) {
        this.$timeout(() => {
          console.log("RRRRRR1");
          //console.dir("removing button disable....");
          $("#cloning-loading-event-data").modal("toggle");
          $(".modal-backdrop").remove();
          //this.$rootScope.postingLoadingStatus = 0;
        }, 1500);
      }
    });

    this.$scope.$on("$destroy", this.PostAJobGlobalApiSyncSingleJobListener);

    this.PostAJobGlobalApiSyncSingleJobListener = this.$rootScope.$on("PostAJobGlobalApiSyncSingleJob", ($event, params) => {
      let event = params.event;

      if (event) {
        this.$timeout(() => {
          //console.dir("removing button disable....");
          console.log("RRRRRRRRR2");
          $("#cloning-loading-event-data").modal("toggle");
          $(".modal-backdrop").remove();
          //this.$rootScope.postingLoadingStatus = 0;
        }, 1500);
      }
    });

    this.$scope.$on("$destroy", this.PostAJobGlobalApiSyncLongTermListener);
    this.$scope.$on("$destroy", this.PostAJobGlobalApiSyncSingleJobListener);
  }

  getNewShiftObject() {
    console.log("getNewShiftObjectgetNewShiftObjectgetNewShiftObjectgetNewShiftObjectgetNewShiftObjectgetNewShiftObjectgetNewShiftObject");
    return {
      startDate: null, //"08/21/2020",
      endDate: null, //"08/21/2020",
      startTime: "9:00 AM", //"8:00",
      endTime: "5:00 PM", //"21:00",
      startTimeHour: "9",
      startTimeMinute: "00",
      startTimeAM: "AM",
      endTimeHour: "5",
      endTimeMinute: "00",
      endTimeAM: "PM",
      overnight: false,
      unpaidBreak: 0,
      hasUnpaidBreak: false,
    };
  }

  getNewLongTermShiftObject() {
    let shift = this.getNewShiftObject();
    shift["weeks"] = "4";
    shift["daysOfWeek"] = [1, 2, 3, 4, 5];
    shift["unpaidBreak"] = 0;
    return shift;
  }

  toggleDayOfWeek(day, force_add) {
    console.log("toggleDayOfWeek");
    console.dir(day);
    console.dir(force_add);
    this.$timeout(() => {
      if (this.shiftLongTermGenerator && this.shiftLongTermGenerator.daysOfWeek) {
        const index = this.shiftLongTermGenerator.daysOfWeek.indexOf(day);
        if (index !== -1 && !force_add) {
          this.shiftLongTermGenerator.daysOfWeek.splice(index, 1);
        } else {
          this.shiftLongTermGenerator.daysOfWeek.push(day);
        }

        this.shiftLongTermGenerator.daysOfWeek = _.uniq(this.shiftLongTermGenerator.daysOfWeek);
      }
      this.validateLongTermShiftGenerator();
    });
  }

  generateTimes(tt, offset) {
    // FROM THE INTERNET - eke, sept 12 2020
    var x = 15; //minutes interval
    var times = []; // time array
    var ap = ["AM", "PM"]; // AM-PM

    if (offset) tt = tt + x;

    for (var i = 0; tt < 24 * 60; i++) {
      var hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
      var mm = tt % 60; // getting minutes of the hour in 0-55 format

      times[i] = {
        formatted: ("" + (hh === 12 || hh === 0 ? 12 : hh % 12)).slice(-2) + ":" + ("0" + mm).slice(-2) + " " + ap[Math.floor(hh / 12)],
        raw: tt,
      };

      tt = tt + x;
    }
    // END FROM THE INTERNET

    return times;
  }

  $onInit() {
    //console.log("Init the date and time object");
    console.log("$onInit");
    const date = new Date();

    const start = moment(new Date(date.setDate(date.getDate() + 6)));
    const end = moment(new Date(date.setDate(date.getDate() + 11)));

    this.startPost = start.format("MM/DD");
    this.endPost = end.format("MM/DD");

    this.validateShifts();

    this.showGenerator = true;

    if (this.event && this.event.shifts && this.event.shifts.length && this.event.shifts[0] !== null) {
      this.showGenerator = false;
      //console.log("These are the shifts:", this.event.shifts);
      this.updateLongTermGenerator(this.event.shifts);
    }

    if (this.event && this.event.id) {
      if (this.event && this.event.id && this.event.is_long_term) {
        this.setLoader();
        if (this.event.numberOfWeeksToScheduleJob && parseFloat(this.event.numberOfWeeksToScheduleJob)) {
          //console.warn("We need to verify the value was saved in the API correctly");
          this.updateLongTermWeeks(this.event.numberOfWeeksToScheduleJob, true)
            .then(() => {
              this.$timeout(() => {
                this.syncWithApi();
              }, 500);
            })
            .catch(() => {
              this.syncWithApi();
            });
        } else {
          this.syncWithApi();
        }
      } else {
        this.syncWithApi();
      }
    }
  }

  updateLongTermGenerator(shifts) {
    //console.log("PROCESSES SHIFTS:", shifts, this.shiftLongTermGenerator);
    console.log("updateLongTermGeneratorupdateLongTermGeneratorupdateLongTermGeneratorupdateLongTermGenerator");
    console.log("updateLongTermGeneratorupdateLongTermGeneratorupdateLongTermGeneratorupdateLongTermGeneratorupdateLongTermGenerator");
    console.dir(shifts);

    if (!this.shiftLongTermGenerator) this.shiftLongTermGenerator = this.getNewLongTermShiftObject();

    if (shifts && shifts.length) {
      this.$timeout(() => {
        this.shiftLongTermGenerator.daysOfWeek = [];

        try {
          shifts.forEach((shift, i) => {
            const dayOfWeek = new Date(shift.startDate).getDay();
            //console.log(shift.startDate, dayOfWeek);
            this.shiftLongTermGenerator.daysOfWeek.push(dayOfWeek);
            console.log("shiftLongTermGenerator shift");
            console.dir(shift);
            if (i === 0) {
              this.shiftLongTermGenerator.startDate = shift.startDate;
              this.shiftLongTermGenerator.startTime = shift.startTime;
              this.shiftLongTermGenerator.startTimeHour = shift.startTimeHour;
              this.shiftLongTermGenerator.startTimeMinute = shift.startTimeMinute;
              this.shiftLongTermGenerator.startTimeAM = shift.startTimeAM;
              this.shiftLongTermGenerator.endTime = shift.endTime;
              this.shiftLongTermGenerator.endTimeHour = shift.endTimeHour;
              this.shiftLongTermGenerator.endTimeMinute = shift.endTimeMinute;
              this.shiftLongTermGenerator.endTimeAM = shift.endTimeAM;
              this.shiftLongTermGenerator.overnight = shift.overnight;
              this.shiftLongTermGenerator.unpaidBreak = shift.unpaidBreak;
              this.shiftLongTermGenerator.hasUnpaidBreak = shift.hasUnpaidBreak;
            }
          });
        } catch (err) {
          console.log("error sifting through shifts");
          console.dir(err);
        } finally {
          this.shiftLongTermGenerator.daysOfWeek = _.uniq(this.shiftLongTermGenerator.daysOfWeek);
          this.validateLongTermShiftGenerator();
        }
      });
    }
  }

  processShifts(shifts) {
    return shifts.map((shift) => {
      const startTime = moment(shift.timeInterval.startTime);
      const endTime = moment(shift.timeInterval.endTime);
      const startTimeFormatted = startTime.format("h:mm a").toUpperCase();

      const tt = this.timeMap[startTimeFormatted];

      return {
        id: shift.id,
        startDate: startTime.format("MM/DD/YYYY"),
        endDate: endTime.format("MM/DD/YYYY"),
        startTime: startTimeFormatted,
        endTime: endTime.format("h:mm a").toUpperCase(),
        overnight: shift.overnight,
        contactInfo: shift.contactInfo,
        possibleEndTimes: this.generateTimes(tt, true),
        unpaidBreak: shift.unpaidBreak,
        hasUnpaidBreak: shift.unpaidBreak > 0,
      };
    });
  }

  activateDatePickers() {
    this.validateShifts();

    $(".main-datepicker").datepicker({
      changeMonth: true,
      changeYear: true,
      minDate: "-0D",
      maxDate: "+1Y",
      yearRange: "0:+1",
    });

    const elem = document.getElementById("range-selection");

    if (elem) {
      this.datepicker = new DateRangePicker(elem, {
        minDate: new Date(),
      });
    }

    const input = document.querySelector('input[name="range-start"]');
    if (input) {
      input.addEventListener("changeDate", () => {
        const rangeStart = document.getElementById("range-start");
        this.shiftGenerator.startDate = rangeStart.value;
        const rangeEnd = document.getElementById("range-end");
        this.shiftGenerator.endDate = rangeEnd.value;
        this.validateShiftGenerator();
      });
    }
    const input2 = document.querySelector('input[name="range-end"]');
    if (input2) {
      input2.addEventListener("changeDate", () => {
        const rangeStart = document.getElementById("range-start");
        this.shiftGenerator.startDate = rangeStart.value;
        const rangeEnd = document.getElementById("range-end");
        this.shiftGenerator.endDate = rangeEnd.value;
        this.validateShiftGenerator();
      });
    }

    const input3 = document.querySelector('input[name="start-date"]');
    if (input3) {
      input3.addEventListener("changeDate", () => {
        const startDate = document.getElementById("start-date");
        this.shiftLongTermGenerator.startDate = startDate.value;
        this.validateLongTermShiftGenerator();
      });
    }
  }

  changeStartDate() {
    console.log("NEW START DATE:", this.shiftLongTermGenerator.startDate);
    const date = new Date(this.shiftLongTermGenerator.startDate);
    this.toggleDayOfWeek(date.getDay(), true);
  }

  generateLongTermShifts(replace, doNotMoveOn) {
    console.log("generateLongTermShifts");
    console.dir(doNotMoveOn);
    console.dir(replace);
    //console.log("GENERATING LONG TERM SHIFTS");
    //console.log(this.shiftLongTermGenerator);
    const startDate = moment(this.shiftLongTermGenerator.startDate).format("MM/DD/YYYY");
    console.log("there is not start date");
    console.dir(startDate);
    if (startDate === "Invalid date" || !startDate) {
      this.unSetLoader();
      alert("Please select a valid start date from the date picker before proceeding.");
      return;
    }

    this.setLoader();
    this.loadingSync = true;
    let DATES = [];

    const dayOfWeek = new Date(startDate).getDay();

    //console.log(startDate, new Date(startDate).getDay());

    this.shiftLongTermGenerator.daysOfWeek.forEach((day) => {
      let offset = 0;
      if (day < dayOfWeek) {
        offset = day + 7 - dayOfWeek;
        //console.log(day, offset);
      } else {
        offset = day - dayOfWeek;
        //console.log(day, offset);
      }

      const startDateDay = new Date(startDate);
      let date = new Date(startDateDay.setDate(startDateDay.getDate() + offset));
      date = moment(date).format("MM/DD/YYYY");
      DATES.push(date);
      //console.log(startDate, date);
    });

    DATES = DATES.sort((a, b) => {
      let timeA = new Date(a).getTime();
      let timeB = new Date(b).getTime();
      return timeA - timeB;
    });
    //console.log("DATES", DATES);

    DATES = DATES.map((d) => {
      const date = this.getNewShiftObject();

      date.overnight = this.shiftLongTermGenerator.overnight;
      date.unpaidBreak =
        this.shiftLongTermGenerator.unpaidBreak && parseFloat(this.shiftLongTermGenerator.unpaidBreak)
          ? parseFloat(this.shiftLongTermGenerator.unpaidBreak)
          : 0;
      date.startTime = this.shiftLongTermGenerator.startTime;
      date.endTime = this.shiftLongTermGenerator.endTime;
      date.startDate = d;
      date.endDate = d;

      const shiftStartTime = new Date(`${date.startDate} ${date.startTime}`);
      const shiftEndTime = new Date(`${date.startDate} ${date.endTime}`);

      if (shiftStartTime.getTime() > shiftEndTime.getTime()) {
        date.overnight = true;
      }

      if (date.overnight) {
        const day = new Date(date.startDate);
        let newdate = new Date(day.setDate(day.getDate() + 1));
        date.endDate = moment(newdate).format("MM/DD/YYYY");
      }

      return date;
    });

    //console.log("unpaidBreak DATES", DATES);
    console.log("WE SHOULD NOT SEE THE EVENT ID HERE");
    console.dir(this.event);
    console.dir("what is replace");
    console.dir(replace);

    //check to see if shifts already exist with IDS .. if they do,
    // that means we need to replace them with the new information otherwise proceed

    if (this.event.id && this.event.shifts && this.event.shifts.length > 0) {
      console.log("this.event.shifts[0].id");
      console.dir(this.event.shifts[0].id);
      if (this.event.shifts[0].id) {
        let numberOfWeeksValid = this.validateNumberOfWeeks();
        if (numberOfWeeksValid === false) {
          this.event.numberOfWeeksToScheduleJob = "3";
        } else {
          this.event.numberOfWeeksToScheduleJob = this.event.numberOfWeeksToScheduleJob;
        }
        this.replaceShifts(this.event.shifts, DATES, replace, doNotMoveOn);
        return;
      }
    }

    this.event.shifts = DATES;
    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
    this.validateShifts();

    if (this.event.clonedFrom) {
      this.cloneNewEvent(DATES, doNotMoveOn);
    } else {
      if (this.event.remote_job) {
        this.createNewRemoteEvent(DATES);
      } else {
        console.log("create new event!");
        this.createNewEvent(DATES, doNotMoveOn);
      }
    }
  }

  validateNumberOfWeeks() {
    let results = null;

    if (this.event.numberOfWeeksToScheduleJob) {
      if (this.event.numberOfWeeksToScheduleJob === "null") {
        results = false;
      } else if (this.event.numberOfWeeksToScheduleJob === null) {
        results = false;
      } else {
        if (parseFloat(this.event.numberOfWeeksToScheduleJob) < 1) {
          results = false;
        } else {
          results = true;
        }
      }
    } else {
      return false;
    }

    return results;
  }

  generateShifts(replace) {
    const dates = this.datepicker.getDates();

    const start = dates[0];
    const end = dates[1];

    const startDate = moment(start).format("MM/DD/YYYY");
    const endDate = moment(end).format("MM/DD/YYYY");

    let DATES = [startDate];

    let newDate = startDate;

    while (new Date(newDate).getTime() < new Date(endDate).getTime()) {
      const day = new Date(newDate);
      let date = new Date(day.setDate(day.getDate() + 1));
      date = moment(date).format("MM/DD/YYYY");
      DATES.push(date);
      newDate = date;
      //console.log(newDate, endDate);
      //console.log(new Date(newDate).getTime(), new Date(endDate).getTime());
    }

    //console.log("DATES", DATES);

    DATES = DATES.map((d) => {
      const date = this.getNewShiftObject();

      date.overnight = this.shiftGenerator.overnight;
      date.unpaidBreak = this.shiftGenerator.unpaidBreak;
      date.startTime = this.shiftGenerator.startTime;
      date.endTime = this.shiftGenerator.endTime;
      date.startDate = d;
      date.endDate = d;

      const shiftStartTime = new Date(`${date.startDate} ${date.startTime}`);
      const shiftEndTime = new Date(`${date.startDate} ${date.endTime}`);

      if (shiftStartTime.getTime() > shiftEndTime.getTime()) {
        date.overnight = true;
      }

      if (date.overnight) {
        const day = new Date(date.startDate);
        let newdate = new Date(day.setDate(day.getDate() + 1));
        date.endDate = moment(newdate).format("MM/DD/YYYY");
      }

      return date;
    });

    //console.log("unpaidBreak DATES", DATES);

    if (replace && this.event.id && this.event.shifts) {
      this.replaceShifts(this.event.shifts, DATES);
      return;
    }

    this.event.shifts = DATES;
    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
    this.validateShifts();

    if (this.event.clonedFrom) {
      this.cloneNewEvent(DATES);
    } else {
      if (this.event.remote_job) {
        this.createNewRemoteEvent(DATES);
      } else {
        this.createNewEvent(DATES);
      }
    }
  }

  addNewShift() {
    let lastShift = JSON.parse(JSON.stringify(this.event.shifts[this.event.shifts.length - 1]));

    if (lastShift.startDate) {
      const date = new Date(lastShift.startDate);
      lastShift.startDate = new Date(date.setDate(date.getDate() + 1));
      lastShift.startDate = moment(lastShift.startDate).format("MM/DD/YYYY");
    }

    if (lastShift.endDate) {
      const date = new Date(lastShift.endDate);
      lastShift.endDate = new Date(date.setDate(date.getDate() + 1));
      lastShift.endDate = moment(lastShift.endDate).format("MM/DD/YYYY");
    }

    lastShift.id = null;

    this.event.shifts.push(lastShift);
    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});

    this.validateShifts();

    this.$events.adjustTimeZone(this.event.contactInfo.zipCode).then(({timeZone, timeZoneDifference}) => {
      let {startTime, endTime} = this.$events.adjustTimeZones(lastShift, timeZone, timeZoneDifference, false);

      lastShift.timeInterval = {
        startTime,
        endTime,
      };

      this.$events.createNewShiftForExistingEvent(this.jobble_id, null, null, lastShift).then((data) => {
        //console.log("Created new shift:", data);
        this.$tracking.reportPostAJobClick("add another shift");
        this.syncWithApi();
      });
    });

    this.$timeout(() => this.activateDatePickers(), 500);
  }

  removeShift(index, shift) {
    if (!this.event || !this.event.shifts || !this.event.shifts.length) return;

    if (this.event.shifts.length === 1) return;

    this.event.shifts.splice(index, 1);
    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});

    this.validateShifts();

    this.$events.deleteShift(shift).then((data) => {
      //console.log("Removed shift:", data);
    });
  }

  syncEndDate(shift) {
    //console.log("Syncing end date");

    if (shift.overnight) {
      const date = new Date(shift.startDate);
      shift.endDate = new Date(date.setDate(date.getDate() + 1));
      shift.endDate = moment(shift.endDate).format("MM/DD/YYYY");
      console.log("updateShift 1");
      this.updateShift(shift);
    } else {
      shift.endDate = shift.startDate;
    }
  }

  getShiftErrors(shift, generator) {
    if (!shift || !shift.startDate || !shift.startTime || !shift.endDate || !shift.endTime) {
      return null; //"All fields are required.";
    }

    let errors = [];

    const startDate = new Date(`${shift.startDate} ${shift.startTime}`);
    const endDate = new Date(`${shift.endDate} ${shift.endTime}`);

    if (startDate.getTime() - new Date().getTime() <= 0) {
      errors.push("the start time of this shift is in the past - please pick a start time that is later than the current time.");
    }

    if (endDate.getTime() - startDate.getTime() <= 0) {
      errors.push("please pick an end time that is later than the start time.");
    } else if (generator && shift.startTime === shift.endTime) {
      errors.push("please pick an end time that is later than the start time.");
    }

    /*
        if (this.development_env !== "dev" && (startDate.getTime() - new Date().getTime() <= GRACE_PERIOD)) {
            errors.push("There must be at least 3 days before the start of the first shift.");
        }
        */

    if (endDate.getTime() - startDate.getTime() > 1000 * 60 * 60 * 24 && !generator) {
      errors.push("please pick a shift length less than 24 hours.");
    }

    if (this.development_env !== "dev" && endDate.getTime() - startDate.getTime() < 1000 * 60 * 60 * 6) {
      errors.push("shifts must be a minimum of 6 hours long.");
    }

    return errors.join(" ");
  }

  getLongTermShiftErrors(shift, generator) {
    if (!shift || !shift.startDate || !shift.startTime || !shift.endTime) {
      return null; //"All fields are required.";
    }

    let errors = [];

    const startDate = new Date(`${shift.startDate} ${shift.startTime}`);
    let endDate = new Date(`${shift.startDate} ${shift.endTime}`);

    if (endDate.getTime() - startDate.getTime() <= 0) {
      endDate = new Date(endDate.getTime() + 1000 * 60 * 60 * 24);
    }

    const shiftLength = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60);

    if (startDate.getTime() - new Date().getTime() <= 0) {
      errors.push("The start time of this shift is in the past - please pick a start time that is later than the current time.");
    }

    /*
        if ((startDate.getTime() - new Date().getTime() <= GRACE_PERIOD)) {
            errors.push("There must be at least 3 days before the start of the first shift.");
        }
        */

    if (!shift.daysOfWeek || !shift.daysOfWeek.length || shift.daysOfWeek.length < 3) {
      errors.push("There must be at least 3 shifts in a recurring job.");
    }
    if (this.development_env !== "dev" && shiftLength < 6) {
      errors.push("Each shift must be a minimum of 6 hours long.");
    }

    // if (endDate.getTime() - startDate.getTime() <= 0) {
    //     errors.push("please pick an end time that is later than the start time.");
    // } else if (generator && shift.startTime === shift.endTime) {
    //     errors.push("please pick an end time that is later than the start time.");
    // }
    //
    // if (endDate.getTime() - startDate.getTime() > 1000 * 60 * 60 * 24 && !generator) {
    //     errors.push("please pick a shift length less than 24 hours.");
    // }

    return errors.join(" ");
  }

  goNext() {
    console.log("goNextKKK");
    console.dir(this.event);
    console.dir(TRIGGER_NEXT_EVENT_NAME);
    console.dir(this.walkthroughState);
    this.$rootScope.$emit(TRIGGER_NEXT_EVENT_NAME, {
      walkthroughState: this.walkthroughState,
    });
  }

  updateShiftGeneratorTime() {
    this.shiftLongTermGenerator.startTime = `${this.shiftLongTermGenerator.startTimeHour}:${this.shiftLongTermGenerator.startTimeMinute} ${this.shiftLongTermGenerator.startTimeAM}`;

    this.shiftLongTermGenerator.endTime = `${this.shiftLongTermGenerator.endTimeHour}:${this.shiftLongTermGenerator.endTimeMinute} ${this.shiftLongTermGenerator.endTimeAM}`;
  }

  validateShiftGenerator() {
    this.generatorShiftValid = true;

    if (!this.shiftGenerator) {
      this.generatorShiftValid = false;
      this.$timeout(() => {
        this.unSetLoader();
      });
      return false;
    }

    let valid = this.$events.validateWorflowShift(this.shiftGenerator, true);

    if (this.shiftGenerator.startTime === this.shiftGenerator.endTime) valid = false;

    this.$timeout(() => {
      this.shiftGenerator.errors = this.getShiftErrors(this.shiftGenerator, true);
      this.generatorShiftValid = valid;
    });

    return valid;
  }

  validateLongTermShiftGenerator() {
    console.log("validateLongTermShiftGenerator");
    this.generatorLongTermShiftValid = true;

    //let valid = true;

    if (!this.shiftLongTermGenerator) {
      this.generatorLongTermShiftValid = false;
      return false;
    }

    let valid = this.$events.validateLongTermGenerator(this.shiftLongTermGenerator, true);

    if (this.shiftLongTermGenerator.startTime === this.shiftLongTermGenerator.endTime) valid = false;

    //console.log(this.shiftLongTermGenerator);
    if (!this.shiftLongTermGenerator.daysOfWeek || !this.shiftLongTermGenerator.daysOfWeek.length) {
      valid = false;
    }

    if (!this.event.numberOfWeeksToScheduleJob) valid = false;

    this.$timeout(() => {
      this.shiftLongTermGenerator.errors = this.getLongTermShiftErrors(this.shiftLongTermGenerator, true);
      this.generatorLongTermShiftValid = valid;
      this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
    });

    return valid;
  }

  determineWhereToGo(doNotMoveOn) {
    let goNext;
    this.hideReplacementGenerator();
    this.$tracking.reportPostAJobSubmitStep("replace date & time");

    console.log("determineWhereToGo");
    console.dir(doNotMoveOn);

    if (doNotMoveOn && doNotMoveOn === true) {
      goNext = false;
    } else {
      goNext = true;
    }

    this.$timeout(() => {
      this.shiftGenerator = this.getNewShiftObject();
    }, 200);

    this.$timeout(() => {
      this.syncWithApi(goNext);
    }, 1000);
  }

  deleteExistingShifts(originalShifts, doNotMoveOn) {
    console.log("deleteExistingShifts");
    console.dir(originalShifts);

    let shiftIds = [];

    if (this.event.shifts) {
      try {
        originalShifts.forEach((shift, i) => {
          shiftIds.push(shift.id);
        });
      } catch (err) {
        console.log("error deleting shifts");
        console.dir(err);
      } finally {
        console.log("shift ids for deletion");
        console.dir(shiftIds);
        this.$timeout(() => {
          this.$events
            .bulkDeleteShifts(shiftIds)
            .then((response) => {
              console.log("response from bulk delete");
              console.dir(response);
              this.determineWhereToGo(doNotMoveOn);
            })
            .catch((err) => {
              console.log("error with bulk delete");
              console.dir(err);
            });
        }, 2000);
      }
    }
  }

  formatPayload(timeIntervalsArray) {
    let shiftArray = [];

    try {
      timeIntervalsArray.forEach((shift, i) => {
        let s = {
          jobbleId: this.jobble_id,
          contactInfo: {
            city: shift.contactInfo.city,
            state: shift.contactInfo.state,
            streetLine1: shift.contactInfo.streetLine1,
            streetLine2: null,
            zipCode: shift.contactInfo.zipCode,
            lat: shift.contactInfo.lat,
            lng: shift.contactInfo.lng,
          },
          timeInterval: {
            startTime: shift.startDateAndTimeForDB,
            endTime: shift.endDateAndTimeForDB,
          },
          overnight: shift.overnight,
        };

        if (shift.unpaidBreak && shift.unpaidBreak > 0) {
          s.unpaidBreak = shift.unpaidBreak;
        }

        shiftArray.push(s);
      });
    } catch (err) {
      console.log("error formatting shifts");
      console.dir(err);
      return err;
    } finally {
      console.log("paylaod for creation");
      console.dir(shiftArray);
      return shiftArray;
    }
  }

  replaceShifts(originalShifts, newShifts, replace, doNotMoveOn) {
    this.$timeout(() => {
      this.replacingShifts = true;
      this.generatingLongTermShifts = true;
    });

    console.log("replaceShifts");
    console.dir(originalShifts);
    console.dir(newShifts);
    console.dir(replace);
    console.dir(this.event);
    console.dir(this.jobble_id);

    //const firstShift = originalShifts[0];
    //originalShifts.splice(0, 1);

    this.$events.adjustTimeZone(this.event.contactInfo.zipCode).then(({timeZone, timeZoneDifference}) => {
      const timeIntervalsArray = newShifts.map((shift) => {
        let {startTime, endTime} = this.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, false);

        return {
          contactInfo: this.event.contactInfo,
          startDateAndTimeForDB: startTime,
          endDateAndTimeForDB: endTime,
          overnight: shift.overnight,
          unpaidBreak: shift.unpaidBreak && parseFloat(shift.unpaidBreak) ? parseFloat(shift.unpaidBreak) : 0,
        };
      });

      console.log("what is the times interval array now");
      console.dir(timeIntervalsArray);

      let payload = this.formatPayload(timeIntervalsArray);

      console.log("payload ready");
      console.dir(payload);
      console.dir(JSON.stringify(payload, null, 4));
      this.$events
        .createNewShiftForExistingEventBulk(payload)
        .then((response) => {
          console.log("Created new shifts:");
          console.dir(response);
          this.deleteExistingShifts(originalShifts, doNotMoveOn);
        })
        .catch((err) => {
          console.error(err);
          console.dir(err);
        });
    });
  }

  displayReplacementGenerator() {
    this.$timeout(() => {
      this.showReplacementGenerator = true;
    });
    this.$timeout(() => {
      this.shiftGenerator = this.getNewShiftObject();
      this.validateShiftGenerator();
    });
    this.$timeout(() => {
      this.activateDatePickers();
      //this.deleteExistingShifts();
    }, 500);
  }

  hideReplacementGenerator() {
    this.$timeout(() => {
      this.showReplacementGenerator = false;
    });
  }

  validateShifts() {
    this.allShiftsValid = true;

    if (!this.event || !this.event.shifts || !this.event.shifts.length) {
      this.allShiftsValid = false;
      return false;
    }

    this.validShifts = this.event.shifts.map((shift) => {
      const valid = this.$events.validateWorflowShift(shift);

      if (!valid) this.allShiftsValid = false;

      return valid;
    });

    let overlapping = false;

    if (this.allShiftsValid) {
      if (!this.$events.validateWorflowShiftsNonOverlapping(this.event.shifts)) {
        this.allShiftsValid = false;
        overlapping = true;
      }
    }

    this.event.shifts = this.event.shifts.map((shift) => {
      if (!shift) return shift;

      shift.errors = this.getShiftErrors(shift);
      if (overlapping) {
        shift.errors = "please select a start & end time that does not overlap with the other shifts in this job posting. " + shift.errors;
        shift.errors = shift.errors.trim();
      }

      return shift;
    });
  }

  cloneNewEvent(shifts) {
    console.log("cloneNewEvent");
    console.dir(this.event);

    this.$events.adjustTimeZone(this.event.contactInfo.zipCode).then(({timeZone, timeZoneDifference}) => {
      const timeIntervalsArray = shifts.map((shift) => {
        let {startTime, endTime} = this.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, false);

        return {
          contactInfo: this.event.contactInfo,
          startDateAndTimeForDB: startTime,
          endDateAndTimeForDB: endTime,
          overnight: shift.overnight,
          unpaidBreak: shift.unpaidBreak && parseFloat(shift.unpaidBreak) ? parseFloat(shift.unpaidBreak) : 0,
        };
      });

      const warehouse_jobble_type = this.$rootScope.warehouse_jobble_type || {};

      const currentUser = this.$auth.getUserData();
      const rate = currentUser.company.defaultPlan.jobblerFeePct;
      const epi = 0.00001;

      let p = 100 - rate * 100;
      let x = parseFloat(this.event.hourly_rate) * 100;
      let z = x / p;

      const payPerHour = Math.round((z + epi) * 100) / 100;

      console.log("payPerHour");
      console.dir(payPerHour);

      const event = {
        name: this.event.shift_title || "DEFAULT_EVENT_TITLE_CLONED",
        openings: this.event.openings || 10,
        typeOfJobPosting: "regular",
        dress_code: this.event.dress_code || DRESS_CODE_DEFAULT,
        timeIntervalsArray,
        isW2: this.event.is_w2,
        jobble_type: parseFloat(this.event.position_type) || warehouse_jobble_type.id || 8,
        manager: this.event.hiring_manager,
        jobble_details: this.event.shift_description,
        is_long_term: this.event.is_long_term,
        weeks: this.event.numberOfWeeksToScheduleJob,
        hourly_rate: payPerHour,
      };

      this.$timeout(() => {
        this.generatingShift = true;
      });

      this.$events
        .saveDraftv2(event, this.event.clonedFrom)
        .then((data) => {
          this.$timeout(() => {
            this.generatingShift = false;
          });
          this.showGenerator = false;

          this.$timeout(() => {
            this.shiftGenerator = this.getNewShiftObject();
            this.validateShiftGenerator();
          });

          //console.log("Created new event from clone:", data);

          this.$tracking.reportPostAJobSubmitStep("clone event");
          this.$tracking.reportPostAJobSubmitStep("date & time");

          this.event.id = data.data.jobblePool.eventId;
          this.$state.transitionTo("postashiftwalkthrough", {eid: this.event.id}, {notify: false});
          //this.$location.search("eid", this.event.id);
          this.$location.search("cid", null);
          this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});

          if (this.event.questions && this.event.questions.length) {
            const data = {
              event_id: this.event.id,
              questions: this.event.questions,
            };

            this.$events
              .updateQuestion(data)
              .then((data) => {
                //console.log("Saved questions for clone:", data);
              })
              .catch((err) => {
                //console.error("Error savings questions for clone:", data);
              });
          }

          if (this.event.requirements && this.event.requirements.length) {
            this.$events.addShiftRequirements(this.event.id, this.event.requirements).then((data) => {
              //console.log("Saved requirements for clone:", data);
            });
          }

          if (this.event.is_long_term) {
            let numberOfWeeksValid = this.validateNumberOfWeeks();

            if (numberOfWeeksValid === false) {
              this.event.numberOfWeeksToScheduleJob = "3";
            } else {
              this.event.numberOfWeeksToScheduleJob = data.data.weeks + "";
            }

            this.updateLongTermWeeks(this.event.numberOfWeeksToScheduleJob)
              .then(() => {
                //console.log("Done syncing with the API after event creation", this.event);
                this.goNext();
                this.$timeout(() => {
                  this.generatingLongTermShifts = false;
                }, 2000);
              })
              .catch((e) => {
                this.goNext();
                this.$timeout(() => {
                  this.generatingLongTermShifts = false;
                }, 2000);
              });
          } else {
            this.syncWithApi();
            this.$timeout(() => {
              this.generatingLongTermShifts = false;
            }, 2000);
          }
        })
        .catch((err) => {
          //console.error("Error creating new event from clone:", err);
        });
    });
  }

  createNewEvent(shifts, doNotMoveOn) {
    this.$events.adjustTimeZone(this.event.contactInfo.zipCode).then(({timeZone, timeZoneDifference, state}) => {
      const timeIntervalsArray = shifts.map((shift) => {

        console.log("shift before on creation");
        console.dir(shift);

        let {startTime, endTime} = this.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, state, false);

        return {
          contactInfo: this.event.contactInfo,
          startDateAndTimeForDB: startTime,
          endDateAndTimeForDB: endTime,
          overnight: shift.overnight,
          unpaidBreak: shift.unpaidBreak && parseFloat(shift.unpaidBreak) ? parseFloat(shift.unpaidBreak) : 0,
        };
      });

      const warehouse_jobble_type = this.$rootScope.warehouse_jobble_type || {};

      const event = {
        name: "DEFAULT_EVENT_TITLE",
        dress_code: DRESS_CODE_DEFAULT,
        openings: 10,
        isW2: this.event.is_w2,
        typeOfJobPosting: "regular",
        timeIntervalsArray,
        jobble_type: this.event.position_type && this.event.position_type !== "null" ? this.event.position_type : warehouse_jobble_type.id || 8,
        manager: this.event.hiring_manager,
        is_long_term: this.event.is_long_term,
      };

      if (this.event.is_long_term) {
        event.weeks = this.event.numberOfWeeksToScheduleJob;
      }

      this.$timeout(() => {
        this.generatingShift = true;
        this.generatingLongTermShifts = true;
      });

      this.$events
        .saveDraftv2(event)
        .then((data) => {
          console.log("createNewEvent Response");
          console.dir(data);

          this.$timeout(() => {
            this.generatingShift = false;
            this.generatingLongTermShifts = false;
          });

          this.showGenerator = false;
          this.$timeout(() => {
            this.shiftGenerator = this.getNewShiftObject();
            this.validateShiftGenerator();
          });
          this.event.id = data.data.jobblePool.eventId;
          this.jobble_id = data.data.jobblePool.jobbles[0].id;
          this.event.back_end_loaded = true;
          this.$state.transitionTo("postashiftwalkthrough", {eid: this.event.id}, {notify: false});
          this.$tracking.reportPostAJobSubmitStep("date & time");

          if (doNotMoveOn === true) {
            this.syncWithApi(false);
          } else {
            this.syncWithApi();
            this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
          }

          if (this.event.is_long_term) {
            //this.event.numberOfWeeksToScheduleJob = event.weeks;
            let numberOfWeeksValid = this.validateNumberOfWeeks();

            if (numberOfWeeksValid === false) {
              this.event.numberOfWeeksToScheduleJob = "3";
            } else {
              this.event.numberOfWeeksToScheduleJob = data.data.weeks + "";
            }

            this.updateLongTermWeeks(this.event.numberOfWeeksToScheduleJob, true)
              .then(() => {
                if (doNotMoveOn === true) {
                } else {
                  this.$timeout(() => {
                    this.goNext();
                  }, 1000);
                }
              })
              .catch((e) => {
                if (doNotMoveOn === true) {
                } else {
                  this.$timeout(() => {
                    this.goNext();
                  }, 1000);
                }
              });
          } else {
            //this.syncWithApi();
            this.$timeout(() => {
              this.generatingLongTermShifts = false;
            }, 500);
          }
        })
        .catch((err) => {
          //console.error("Error creating new event:", err);
          //TODO alert("Error creating an event, please try again.");
        });
    });
  }

  syncWithApi(goNext) {
    //console.log("sync with API is being called");

    this.loadingSync = true;
    this.setLoader();
    this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then((data) => {
      console.log("sync with API is done", data.data);
      //console.log("DATA BEFORE THE API SYNC:", JSON.stringify(this.event, null, 4));
      this.jobble_id = data.data.subEvents[0].deduppedJobbles[0].id;
      this.event.is_long_term = data.data.isLongTerm;

      if (this.event.is_long_term === true) {
        let numberOfWeeksValid = this.validateNumberOfWeeks();

        console.log("numberOfWeeksValid");
        console.dir(numberOfWeeksValid);

        if (numberOfWeeksValid === false) {
          data.data.weeks = "11";
          this.event.numberOfWeeksToScheduleJob = "11";
        } else {
          this.event.numberOfWeeksToScheduleJob = data.data.weeks + "";
        }
      }

      const jobbleType = data.data.subEvents[0].deduppedJobbles[0].jobbleType;
      this.event.position_type = jobbleType.id + "";

      let update_is_long_term = false;
      let is_long_term_value = null;

      if (this.$rootScope.warehouse_jobble_type && this.$rootScope.warehouse_jobble_type.id) {
        if (this.$rootScope.warehouse_jobble_type.id + "" === this.event.position_type + "") {
          //console.log("Picked Warehouse Job Type");

          //this.event.forced_long_term = true;

          if (!this.event.is_long_term) {
            //update_is_long_term = true;
            //is_long_term_value = true;
          }
        }
      }

      if (this.$rootScope.event_jobble_type && this.$rootScope.event_jobble_type.id) {
        if (this.$rootScope.event_jobble_type.id + "" === this.event.position_type + "") {
          //console.log("Picked Event Staff Job Type");
          this.event.forced_one_time = true;

          if (this.event.is_long_term) {
            //update_is_long_term = true;
            //is_long_term_value = false;
          }
        }
      }

      //console.log("update_is_long_term", update_is_long_term, is_long_term_value);
      let shifts = this.processShifts(data.data.subEvents[0].deduppedJobbles[0].shifts);

      shifts = shifts.sort((a, b) => {
        return new Date(`${a.startDate} ${a.startTime}`).getTime() - new Date(`${b.startDate} ${b.startTime}`).getTime();
      });

      //console.log("DATA AFTER THE API SYNC:", JSON.stringify(this.event, null, 4));

      //console.log("shifts after processing");
      //console.dir(shifts);
      //console.dir(this.event);

      this.$events.adjustTimeZone(this.event.contactInfo.zipCode).then(({
                                                                          timeZone,
                                                                          timeZoneDifference,
                                                                          state,
                                                                          browserTimeZone
                                                                        }) => {
        this.$timeout(() => {
          //console.log("This was before there was a change");

          try {
            this.event.shifts = shifts.map((shift) => {

              let remove;
              if (timeZone === "America/Phoenix") {
                remove = false;
              } else {
                remove = false;
              }

              let {startTime, endTime} = this.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, state, true);

              startTime = new Date(startTime);
              endTime = new Date(endTime);

              startTime = moment(startTime).tz(timeZone);
              endTime = moment(endTime).tz(timeZone);

              let start = new Date(`${shift.startDate} ${shift.startTime}`);
              let end = new Date(`${shift.endDate} ${shift.endTime}`);
              let startMoment = moment(start).tz(shift.contactInfo.timeZoneId);
              let endMoment = moment(end).tz(shift.contactInfo.timeZoneId);

              return {
                id: shift.id,
                startDate: startMoment.format("MM/DD/YYYY"),
                endDate: endMoment.format("MM/DD/YYYY"),
                startTime: startMoment.format("h:mm a").toUpperCase(),
                startTimeHour: startMoment.format("h").toUpperCase(),
                startTimeMinute: startMoment.format("mm").toUpperCase(),
                startTimeAM: startMoment.format("a").toUpperCase(),
                endTime: endMoment.format("h:mm a").toUpperCase(),
                endTimeHour: endMoment.format("h").toUpperCase(),
                endTimeMinute: endMoment.format("mm").toUpperCase(),
                endTimeAM: endMoment.format("a").toUpperCase(),
                overnight: shift.overnight,
                contactInfo: shift.contactInfo,
                possibleEndTimes: shift.possibleEndTimes,
                unpaidBreak: shift.unpaidBreak,
                hasUnpaidBreak: shift.unpaidBreak > 0,
              };
            });
          } finally {
            console.log("this.event.shifts");
            console.dir(this.event.shifts);
            this.updateLongTermGenerator(this.event.shifts, goNext);
            //this.$scope.$apply();
          }

          if (goNext !== false) {
            this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
          }

          //this.validateShifts();

          this.$timeout(() => {
            this.loadingSync = false;
          }, 800);

          this.$timeout(() => {
            this.unSetLoader();
          }, 1000);

          console.log("update_is_long_term");
          console.dir(update_is_long_term);

          if (update_is_long_term) {
            this.updateLongTermGenerator(this.event.shifts);

            this.$timeout(() => {
              this.event.is_long_term = is_long_term_value;

              this.$timeout(() => {
                this.activateDatePickers();
              }, 300);

              if (is_long_term_value && this.event.shifts && this.event.shifts.length && this.event.id) {
                this.$timeout(() => {
                  this.generatingLongTermShifts = true;
                });
                this.$events.saveEventLongTermShortTerm(this.event.id, is_long_term_value).then((data) => {
                  //console.log("Updated short/long term event:", data);
                  this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
                  this.generateLongTermShifts(true);
                });
              } else {
                if (this.event.id) {
                  this.$events.saveEventLongTermShortTerm(this.event.id, is_long_term_value).then((data) => {
                    //console.log("Updated short/long term event:", data);
                    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
                  });
                }
              }
            });
          } else {
            if (goNext === true) {
              this.goNext();
            } else {
              this.generatingLongTermShifts = false;
              this.loadingSync = false;
              this.removeLoadingBar();
            }
          }
        });
      });
    });
  }

  removeLoadingBar() {
    this.$timeout(() => {
      if (this.$rootScope && this.$rootScope.progress) {
        this.$rootScope.progress.complete();
      }
    }, 800);
  }

  createNewRemoteEvent(shifts) {
    //console.log("Creating new remote job");

    // Maine Time Zone: 04743
    this.$events.adjustTimeZone("04743").then(({timeZone, timeZoneDifference}) => {
      const timeIntervalsArray = shifts.map((shift) => {
        let {startTime, endTime} = this.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, false);

        return {
          contactInfo: this.event.contactInfo,
          startDateAndTimeForDB: startTime,
          endDateAndTimeForDB: endTime,
          overnight: shift.overnight,
          unpaidBreak: shift.unpaidBreak && parseFloat(shift.unpaidBreak) ? parseFloat(shift.unpaidBreak) : 0,
        };
      });

      const remote_jobble_type = this.$rootScope.remote_jobble_type || {};

      const event = {
        name: "DEFAULT_REMOTE_TITLE",
        dress_code: DRESS_CODE_DEFAULT,
        openings: 10,
        typeOfJobPosting: "regular",
        timeIntervalsArray,
        jobble_type: remote_jobble_type.id || 92,
        manager: this.event.hiring_manager,
        is_long_term: this.event.is_long_term,
      };

      if (this.event.is_long_term) {
        event.weeks = this.event.numberOfWeeksToScheduleJob;
      }

      this.$timeout(() => {
        this.generatingShift = true;
        this.generatingLongTermShifts = true;
      });

      this.$events
        .saveDraftv2(event)
        .then((data) => {
          this.$timeout(() => {
            this.generatingShift = false;
          });
          this.showGenerator = false;

          this.$timeout(() => {
            this.shiftGenerator = this.getNewShiftObject();
            this.validateShiftGenerator();
          });

          //console.log("Created new event:", data);

          this.event.id = data.data.jobblePool.eventId;
          this.event.contactInfo = data.data.jobblePool.jobbles[0].location;
          this.$state.transitionTo("postashiftwalkthrough", {eid: this.event.id}, {notify: false});
          //this.$location.search("eid", this.event.id);
          this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});

          this.$tracking.reportPostAJobSubmitStep("date & time");

          if (this.event.is_long_term) {
            this.updateLongTermWeeks(this.event.numberOfWeeksToScheduleJob)
              .then(() => {
                //console.log("Done syncing with the API after event creation", this.event);
                this.goNext();
                this.$timeout(() => {
                  this.generatingLongTermShifts = false;
                }, 2000);
              })
              .catch((e) => {
                this.goNext();
                this.$timeout(() => {
                  this.generatingLongTermShifts = false;
                }, 2000);
              });
          } else {
            this.syncWithApi();
            this.$timeout(() => {
              this.generatingLongTermShifts = false;
            }, 2000);
          }
        })
        .catch((err) => {
          //console.error("Error creating new event:", err);
          //TODO alert("Error creating an event, please try again.");
        });
    });
  }

  changedUnpaidShift(shift, dontUpdate) {
    if (!shift.hasUnpaidBreak) {
      shift.unpaidBreak = 0;
      if (!dontUpdate) {
        console.log("updateShift 2");
        this.updateShift(shift);
      }
    } else {
      shift.unpaidBreak = 30;
      if (!dontUpdate) {
        console.log("updateShift 3");
        this.updateShift(shift);
      }
    }
  }

  updateShiftGenerator(shift) {
    this.$timeout(() => {
      if (shift.unpaidBreak > 0) {
        shift.hasUnpaidBreak = true;
      } else {
        shift.hasUnpaidBreak = false;
      }
    });
  }

  updateShift(shift, fromHTML, loc) {
    const tt = this.timeMap[shift.startTime];
    shift.possibleEndTimes = this.generateTimes(tt, true);

    if (fromHTML) {
      console.log("Triggered from ng-change update:", loc);
    }

    if (shift.unpaidBreak > 0) {
      shift.hasUnpaidBreak = true;
    }

    if (!shift.id) {
      console.warn("Trying to update shift without an ID");
      return;
    }

    if (!this.$events.validateWorflowShift(shift)) {
      console.warn("Skipping sending invalid shift to API");
      return;
    }

    if (!this.$events.validateWorflowShiftsNonOverlapping(this.event.shifts)) {
      console.warn("Skipping sending invalid overlapping shift to API");
      return;
    }

    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});

    this.$timeout(() => {
      this.savingStep = true;
    });

    this.$events.adjustTimeZone(this.event.contactInfo.zipCode).then(({timeZone, timeZoneDifference}) => {
      let {startTime, endTime} = this.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, false);

      var tempShift = {
        id: shift.id,
        overnight: shift.overnight,
        unpaidBreak: shift.unpaidBreak,
        timeInterval: {
          startTime,
          endTime,
        },
      };

      this.$events.updateExistingShift(tempShift, true).then(
        (data) => {
          this.$timeout(() => {
            this.savingStep = false;
          });
          //console.log("Updated shift:", data);
        },
        (err) => {
        }
      );
    });
  }

  updateSchedule() {
    let weeks = this.numberOfWeeksToScheduleJob;
    let scheduledWeeks = null;

    if (weeks === "1 Week") {
      scheduledWeeks = 0;
    } else if (weeks === "2 Weeks") {
      scheduledWeeks = 1;
    } else if (weeks === "3 Weeks") {
      scheduledWeeks = 2;
    } else if (weeks === "4 Weeks") {
      scheduledWeeks = 3;
    } else if (weeks === "5 Weeks") {
      scheduledWeeks = 4;
    } else if (weeks === "6 Weeks") {
      scheduledWeeks = 5;
    } else if (weeks === "7 Weeks") {
      scheduledWeeks = 6;
    } else if (weeks === "8 Weeks") {
      scheduledWeeks = 7;
    } else if (weeks === "9 Weeks") {
      scheduledWeeks = 8;
    } else if (weeks === "10 Weeks") {
      scheduledWeeks = 9;
    }

    this.event.numberOfWeeksToScheduleJob = scheduledWeeks;
  }

  updateShortTermLongTerm(is_long_term) {
    //console.log("updateShortTermLongTerm");
    //console.dir(is_long_term);

    if (this.event.forced_long_term || this.event.forced_one_time) {
      if (this.event.forced_long_term) {
        return alert("Warehouse jobs can only be posted as recurring jobs");
      }
      if (this.event.forced_one_time) {
        return alert("Event jobs can only be posted as one-time jobs");
      }
    }

    if (this.event.shifts && this.event.shifts.length && this.event.id) {
      let confirmed = confirm("Are you sure you want to switch the post type?" + " This may delete previous shifts you've created!");

      if (!confirmed) {
        return;
      } else {
        this.updateIsLongTerm();
      }
    }

    this.$timeout(() => {
      this.event.is_long_term = is_long_term;
      this.$timeout(() => this.activateDatePickers(), 250);
      if (is_long_term && this.event.shifts && this.event.shifts.length && this.event.id) {
        this.$timeout(() => {
          this.generatingLongTermShifts = true;
        });
        this.$events.saveEventLongTermShortTerm(this.event.id, is_long_term).then((data) => {
          //console.log("Updated short/long term event:", data);
          this.generateLongTermShifts(true);
          this.syncWithApi(false);
        });
      } else {
        if (this.event.id) {
          this.$events.saveEventLongTermShortTerm(this.event.id, is_long_term).then((data) => {
            //console.log("Updated short/long term event:", data);
            this.syncWithApi(false);
          });
          this.clearLongTermWeek();
        }
      }
    });
  }

  clearLongTermWeek(weeks) {
    //console.log("clearLongTermWeek");
    this.$timeout(() => {
      if (this.event.id) {
        this.$events.saveEventLongTermWeeks(this.event.id, null).then((data) => {
        });
      }
    });
  }

  updateIsLongTerm() {
  }

  updateLongTermWeeks(weeks, skip) {
    console.log("updateLongTermWeeks -- date and time controller");
    console.dir(weeks);
    console.dir(skip);
    this.setLoader();
    this.loadingSync = true;

    if (angular.isUndefined(weeks) || weeks === "undefined" || weeks === 0 || weeks === "0") {
      console.log("we have no weeks...do nothing");
      //this.syncWithApi();
      this.$timeout(() => {
        console.log("check after timeout...");
        console.dir(this.event);
        let newWeeks = this.event.numberOfWeeksToScheduleJob;
        console.log("weeks after timeout");
        console.dir(newWeeks);
        if (angular.isUndefined(weeks) || weeks === "undefined") {
          console.log("not detecting weeks");
          this.$timeout(() => {
            this.generatingLongTermShifts = false;
          }, 2000);

          if (!skip) {
            this.$timeout(() => {
              this.syncWithApi(true);
            }, 1000);
          } else {
            this.unSetLoader();
            this.loadingSync = false;
          }
        } else {
          return new Promise((resolve) => {
            this.$timeout(() => {
              console.log("resolving..");
              console.dir(resolve);
              this.event.numberOfWeeksToScheduleJob = newWeeks;
              //this.$rootScope.$emit("SetNewWeeksOnChange", this.event);
              if (this.event.id) {
                this.generatingLongTermShifts = true;
                this.$events
                  .saveEventLongTermWeeks(this.event.id, newWeeks)
                  .then((data) => {
                    this.$timeout(() => {
                      this.generatingLongTermShifts = false;
                    }, 1000);
                    console.log("Updated long term event weeks:", data);
                    console.log("skip : " + skip);
                    //zzzzzz
                    resolve();
                    if (!skip) {
                      this.$timeout(() => {
                        this.syncWithApi();
                      }, 1000);
                    } else {
                      this.unSetLoader();
                      this.loadingSync = false;
                    }
                  })
                  .catch((e) => {
                    //console.error(e);
                    resolve();
                  });
              } else {
                this.unSetLoader();
                this.loadingSync = false;
                resolve();
              }
            });
          });
        }
      }, 2000);
    } else {
      return new Promise((resolve) => {
        this.$timeout(() => {
          this.event.numberOfWeeksToScheduleJob = weeks;
          //this.$rootScope.$emit("SetNewWeeksOnChange", this.event);
          if (this.event.id) {
            this.generatingLongTermShifts = true;
            this.$events
              .saveEventLongTermWeeks(this.event.id, weeks)
              .then((data) => {
                this.$timeout(() => {
                  this.generatingLongTermShifts = false;
                }, 2000);
                console.log("Updated long term event weeks:", data);
                console.log("skip : " + skip);
                resolve();
                if (!skip) {
                  this.$timeout(() => {
                    this.syncWithApi();
                  }, 1000);
                } else {
                  this.unSetLoader();
                  this.loadingSync = false;
                }
              })
              .catch((e) => {
                //console.error(e);
                resolve();
              });
          } else {
            this.unSetLoader();
            this.loadingSync = false;
            resolve();
          }
        });
      });
    }
  }

  setScheduleForJob() {
    let weeks = this.event.numberOfWeeksToScheduleJob;

    this.$events.setJobSchedule(this.jobble_id, weeks).then(
      (r) => {
        //console.log("Updated job schedule:", r);
        this.$timeout(() => {
          this.$rootScope.$emit("JobHasBeenScheduled", this.event);
        });
      },
      (error) => {
        //console.error(error);
      }
    );
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }
}

DateandtimeController.$inject = [
  "$localStorage",
  "$rootScope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "ngProgressFactory",
  "$timeout",
  "tracking",
  "events",
  "$location",
  "$scope",
];

export default DateandtimeController;



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/scenes/dateandtime/dateandtime.controller.js